<template>
  <div class="compound public-content">
    <div class="breadcrumb">码管理</div>
    <div class="add-category">
      <div class="keywords">
        <span style="margin-right:10px">码名称:</span>
        <el-input v-model="barName" placeholder="请输入码名称" clearable></el-input>
        <span style="margin:0 10px 0 20px">码类型:</span>
        <el-select clearable v-model="codeType" placeholder="请选择">
          <el-option label="" value="">全部</el-option>
          <el-option label="条形码" value="BAR_CODE"></el-option>
          <el-option label="双影像二维码" value="QR_CODE"></el-option>
          <el-option label="标识" value="IDENTITY"></el-option>
          <el-option label="锁线条码" value="LOCKWIRE_BAR_CODE"></el-option>
          <el-option label="上下条码" value="VERTICAL_BAR_CODE"></el-option>
          <el-option label="祝福墙二维码" value="BLESSING_WALL_QR_CODE"></el-option>
          <el-option label="客户备注" value="REMARK"></el-option>
          <el-option label="照片张数备注" value="PHOTO_COUNT_REMARK"></el-option>
          <el-option label="双面照片张数备注" value="DOUBLE_SIDE_PHOTO_COUNT_REMARK"></el-option>
        </el-select>
      </div>
      <div>
        <el-button round @click="queryInfo.pageNum = 1, onSubmit()">查询</el-button>
        <el-button round type="primary" v-permission="'pts:admin:bar:add'" @click="createEdit('add')">创建码 </el-button>
      </div>
    </div>
    <div class="right-main">
      <div class="data-list">
        <el-table :data="tableData" border>
          <el-table-column label="码名称" min-width="100px" prop="barName"></el-table-column>
          <el-table-column label="码类型" min-width="100px" prop="codeType">
            <template slot-scope="scope"> {{ scope.row.codeType === 'BAR_CODE' ? '条形码' : scope.row.codeType === 'IDENTITY' ? '标识' : scope.row.codeType === 'QR_CODE' ? '双影像二维码' : scope.row.codeType ===
              'LOCKWIRE_BAR_CODE' ? '锁线条码' : scope.row.codeType === 'REMARK' ? '客户备注' : scope.row.codeType === 'VERTICAL_BAR_CODE' ? '上下条码' : scope.row.codeType === 'BLESSING_WALL_QR_CODE' ? '祝福墙二维码'
                : scope.row.codeType === 'PHOTO_COUNT_REMARK' ? '照片张数备注' : scope.row.codeType === 'DOUBLE_SIDE_PHOTO_COUNT_REMARK' ? '双面照片张数备注' : '未定义字段' }} </template>
          </el-table-column>
          <el-table-column label="码规格" prop="bleedName" min-width="100px">
            <template v-slot='scope'>
              <p style="fontSize:12px" v-if="scope.row.codeType !== 'IDENTITY'">宽度：{{ scope.row.width }}mm</p>
              <p style="fontSize:12px" v-if="scope.row.codeType !== 'IDENTITY'">高度：{{ scope.row.height }}mm</p>
              <p style="fontSize:12px" v-if="scope.row.codeType === 'VERTICAL_BAR_CODE'">字号：{{ scope.row.fontSize }}px</p>
              <p style=" fontSize:12px">{{ (scope.row.portrait === 'top' ? '距上：' : '距下：') + scope.row.portraitParam + 'mm' }}</p>
              <p style="fontSize:12px">{{ (scope.row.transverse === 'left' ? '距左：' : '距右：') + scope.row.transverseParam + 'mm' }}</p>
            </template>
          </el-table-column>
          <el-table-column label="操作" min-width="100px">
            <template v-slot="scope">
              <span class="color-blue" v-permission="'pts:admin:bar:update'" @click="createEdit('edit', scope.row)">编辑</span><br>
              <span class="color-blue" v-permission="'pts:admin:bar:delete'" @click="deleteId = scope.row.id, deleteName = scope.row.barName, deleteDialog = true">删除</span>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </div>
    <!--    分页-->
    <v-pagination class="v-pagination" :queryInfo="queryInfo" @changePage="changePage"></v-pagination>
    <!-- 删除确认 -->
    <el-dialog :close-on-click-modal="false" title="确认" :visible.sync="deleteDialog" width="30%">
      <span>确认删除 {{ deleteName }}？</span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="deleteDialog = false">取 消</el-button>
        <el-button type="primary" @click="deleteCode(deleteId)">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import VPagination from '@/components/Pagination/index'
import { barListPage, barAdd, barDelete } from '@/api/pms'
export default {
  name: 'compound',
  components: {
    VPagination
  },
  data () {
    return {
      deleteName: '',
      deleteId: '',
      deleteDialog: false,
      composeList: [],
      barName: '',
      codeType: '',
      queryInfo: {
        pageNum: 1, // 当前显示第几页
        pageSize: 10, // 每一页显示条数
        total: 0
      },
      compoundType: [],
      tableData: []
    }
  },
  created () {
    if (sessionStorage.getItem('searchFlag') === 'true') {
      let obj = JSON.parse(sessionStorage.getItem('queryParams'))
      this.barName = obj.barName
      this.codeType = obj.codeType
      this.queryInfo = JSON.parse(sessionStorage.getItem('queryInfo'))
      sessionStorage.removeItem('searchFlag')
    } else {
      // 首次进入列表页,清除缓存中的搜索条件
      sessionStorage.removeItem('queryParams')
      sessionStorage.removeItem('queryInfo')
    }
    this.onSubmit()
  },
  destroyed () {
    // 销毁
    console.log('页面销毁')
    sessionStorage.removeItem('searchFlag')
  },
  methods: {
    createEdit (type, row) {
      let obj = {
        codeType: this.codeType,
        barName: this.barName
      }
      sessionStorage.setItem('queryInfo', JSON.stringify(this.queryInfo))
      sessionStorage.setItem('queryParams', JSON.stringify(obj))
      if (type === 'add') this.$router.push({ path: '/createCode' })
      if (type === 'edit') this.$router.push({ path: '/createCode', query: { id: row.id } })
    },
    deleteCode (id) {
      barDelete(id).then(res => {
        if (res.data.success) {
          this.$message.success('删除成功')
          this.onSubmit()
          this.deleteDialog = false
        }
      })
    },
    onSubmit () {
      if (sessionStorage.getItem('searchFlag')) {
        let obj = {
          codeType: this.codeType,
          barName: this.barName
        }
        sessionStorage.setItem('queryInfo', JSON.stringify(this.queryInfo))
        sessionStorage.setItem('queryParams', JSON.stringify(obj))
      }
      barListPage({ pageNum: this.queryInfo.pageNum, pageSize: this.queryInfo.pageSize, codeListVO: { codeType: this.codeType, barName: this.barName } }).then(res => {
        if (res.data.success) {
          if (res.data.data.records.length === 0 && res.data.data.total !== 0 && this.queryInfo.pageNum !== 1) {
            this.queryInfo.pageNum--
            this.onSubmit(this.queryInfo)
          }
          this.tableData = res.data.data.records
          this.queryInfo.total = res.data.data.total
        }
      })
    },
    deleteMenuOK () {
      this.onSubmit()
    },
    addMenuOK () {
      this.onSubmit()
    },
    changePage (val) {
      this.queryInfo = val
      this.onSubmit()
    }
  }
}
</script>
<style scoped lang="less">
.compound {
  .add-category {
    justify-content: space-between;
  }

  .keywords {
    display: flex;
    justify-content: space-around;
    // width: 750px;
    align-items: center;

    .el-input {
      width: 180px;
    }
  }
}
</style>
